<template>
  <Stage>
    <div :class="{ 'item-and-price': true, show: show }">
      <img
        ref="image"
        :src="imageUrl"
        @load="show = true"
      />
      <h1 class="price">{{ price }}</h1>
    </div>

    <ButtonGroup v-if="showButtons">
      <Button
        exam
        disable-mouse
        :label="$t('item_price_button_yes_web')"
        @click="$emit('answered', 'yes')"
        :keys="['z']"
      />
      <Button
        exam
        disable-mouse
        :label="$t('item_price_button_no_web')"
        @click="$emit('answered', 'no')"
        :keys="['m']"
      />
    </ButtonGroup>
  </Stage>
</template>

<script>
import { Button, Stage } from '@neurotrack/web-shared-components'
import ButtonGroup from '@/components/ButtonGroup.vue'
import Timer from '@/mixins/timer'

export default {
  name: 'ItemPriceTrial',
  components: { Button, Stage, ButtonGroup },
  mixins: [Timer],
  data() {
    return {
      show: false,
      prevImageUrl: ''
    }
  },
  props: {
    imageUrl: String,
    price: String,
    step: Number,
    showButtons: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    step: {
      handler() {
        this.show = this.imageUrl === this.prevImageUrl
        this.prevImageUrl = this.imageUrl
        this.clearTimer()
        this.setTimer(4000, 'delay').then(() => {
          this.$emit('answered', null)
        })
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.item-and-price {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}
.item-and-price.show {
  visibility: visible;
}
.price {
  margin-left: 100px;
  font-size: 2.5rem;
}
.item-and-price > img {
  margin-right: 100px;
  width: 250px;
  height: auto;
}
</style>
